import React from "react";
import Screen from "./navbar";
import Body from './body';


const Components = () => {
  return (
    <>
      <Screen />
      <Body/>
    </>
  );
};

export default Components